export const fractionDisplay = (amountInCents, maxFraction = 2) => {
  // if amount does not have leftover cents - display 0 eg. $10
  if (amountInCents % 100 === 0) return 0
  // otherwise - display max eg. $10.05
  return maxFraction
}
